import { defineMessages } from 'react-intl-next';

export const keywords = defineMessages({
	create: {
		id: 'editorExtensionLinkCreate.keyword.create',
		defaultMessage: 'create',
		description:
			'Keyword implies object creation — keywords are special terms recognised within user search queries to help improve search suggestions when searching for quick insert options and are not displayed to the user',
	},
	issue: {
		id: 'editorExtensionLinkCreate.keyword.issue',
		defaultMessage: 'work item',
		description:
			'Keyword implies jira issue — keywords are special terms recognised within user search queries to help improve search suggestions when searching for quick insert options and are not displayed to the user',
	},
	ticket: {
		id: 'editorExtensionLinkCreate.keyword.ticket',
		defaultMessage: 'ticket',
		description:
			'Keyword implies jira ticket (synonymous for issue) — keywords are special terms recognised within user search queries to help improve search suggestions when searching for quick insert options and are not displayed to the user',
	},
	raise: {
		id: 'editorExtensionLinkCreate.keyword.raise',
		defaultMessage: 'raise',
		description:
			'Keyword implies raising an issue — keywords are special terms recognised within user search queries to help improve search suggestions when searching for quick insert options and are not displayed to the user',
	},
	new: {
		id: 'editorExtensionLinkCreate.keyword.new',
		defaultMessage: 'new',
		description:
			'Keyword implies creation something new — keywords are special terms recognised within user search queries to help improve search suggestions when searching for quick insert options and are not displayed to the user',
	},
	space: {
		id: 'editorExtensionLinkCreate.keyword.space',
		defaultMessage: 'space',
		description:
			'Keyword implies confluence space — keywords are special terms recognised within user search queries to help improve search suggestions when searching for quick insert options and are not displayed to the user',
	},
	publish: {
		id: 'editorExtensionLinkCreate.keyword.publish',
		defaultMessage: 'publish',
		description:
			'Keyword implies publishing content — keywords are special terms recognised within user search queries to help improve search suggestions when searching for quick insert options and are not displayed to the user',
	},
	page: {
		id: 'editorExtensionLinkCreate.keyword.page',
		defaultMessage: 'page',
		description:
			'Keyword implies page of content — keywords are special terms recognised within user search queries to help improve search suggestions when searching for quick insert options and are not displayed to the user',
	},
});

export const jiraExtensionMessages = defineMessages({
	extensionTitle: {
		id: 'editorExtensionLinkCreate.jiraIssue.quickInsert.title',
		defaultMessage: 'Create Jira issue',
		description:
			'Title displayed to the user on option in the quick insert menu for activating the extension',
	},
	extensionTitleIssueTerminologyRefreshM4: {
		id: 'editorExtensionLinkCreate.jiraIssue.quickInsert.title-issue-terminology-refresh-m4',
		defaultMessage: 'Create Jira work item',
		description:
			'Title displayed to the user on option in the quick insert menu for activating the extension',
	},
	extensionDescription: {
		id: 'editorExtensionLinkCreate.jiraIssue.quickInsert.description',
		defaultMessage: 'Create an issue inline and insert the issue as a link',
		description: 'Message that elaborates on the title for the quick insert option',
	},
	extensionDescriptionIssueTerminologyRefreshM4: {
		id: 'editorExtensionLinkCreate.jiraIssue.quickInsert.description-issue-terminology-refresh-m4',
		defaultMessage: 'Create a work item inline and insert the work item as a link',
		description: 'Message that elaborates on the title for the quick insert option',
	},
});

export const confluenceExtensionMessages = defineMessages({
	extensionTitle: {
		id: 'editorExtensionLinkCreate.confluencePage.quickInsert.title',
		defaultMessage: 'Create Confluence page',
		description:
			'Title displayed to the user on option in the quick insert menu for activating the extension',
	},
	extensionDescription: {
		id: 'editorExtensionLinkCreate.confluencePage.quickInsert.description',
		defaultMessage: 'Create a new page and insert it as a link',
		description: 'Message that elaborates on the title for the quick insert option',
	},
});

export const jiraIssueMessages = defineMessages({
	title: {
		id: 'editorExtensionLinkCreate.jiraIssue.title',
		defaultMessage: 'Create new issue',
		description: 'Title for the Jira issue create modal',
	},
	titleIssueTerminologyRefreshM4: {
		id: 'editorExtensionLinkCreate.jiraIssue.title-issue-terminology-refresh-m4',
		defaultMessage: 'Create new work item',
		description: 'Title for the Jira issue create modal',
	},
	successFlagTitle: {
		id: 'editorExtensionLinkCreate.jiraIssue.successFlag.title',
		defaultMessage: 'Issue created',
		description:
			'Success message informing the user that the Jira Issue was successfully created and published',
	},
	successFlagTitleIssueTerminologyRefreshM4: {
		id: 'editorExtensionLinkCreate.jiraIssue.successFlag.title-issue-terminology-refresh-m4',
		defaultMessage: 'Work item created',
		description:
			'Success message informing the user that the Jira Issue was successfully created and published',
	},
	successFlagDescription: {
		id: 'editorExtensionLinkCreate.jiraIssue.successFlag.description',
		defaultMessage: 'Your issue has been created',
		description: 'Description message informing user that the Jira issue has been created',
	},
	successFlagDescriptionIssueTerminologyRefreshM4: {
		id: 'editorExtensionLinkCreate.jiraIssue.successFlag.description-issue-terminology-refresh-m4',
		defaultMessage: 'Your work item has been created',
		description: 'Description message informing user that the Jira issue has been created',
	},
	successFlagActionOpen: {
		id: 'editorExtensionLinkCreate.jiraIssue.successFlag.action.open',
		defaultMessage: 'Open in Jira',
		description: 'Button label to open the newly created Issue in Jira',
	},
});

export const confluencePageMessages = defineMessages({
	title: {
		id: 'editorExtensionLinkCreate.confluencePage.title',
		defaultMessage: 'Create new page',
		description: 'Title for the create modal that creates a confluence page when submitted',
	},
	newDraftTitle: {
		id: 'editorExtensionLinkCreate.confluencePage.newDraftTitle',
		defaultMessage: 'Untitled page',
		description: 'Title for the newly created draft',
	},
	successFlagTitle: {
		id: 'editorExtensionLinkCreate.confluencePage.successFlag.title',
		defaultMessage: 'Page created',
		description:
			'Success message informing the user that the confluence page was successfully created and published',
	},
	successFlagDescription: {
		id: 'editorExtensionLinkCreate.confluencePage.successFlag.description',
		defaultMessage: 'Your page has been created',
		description: 'Description message informing user that the page created has been published',
	},
	successFlagActionOpen: {
		id: 'editorExtensionLinkCreate.confluencePage.successFlag.action.open',
		defaultMessage: 'Open in Confluence',
		description: 'Button label to open the newly created page in Confluence',
	},
});
